export default __webpack_public_path__ + "4e423b3.png";